import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '视频', to: '/category/video' },
  { label: '软件', to: '/category/software' },
  { label: '教程', to: '/category/tutorial' },
  { label: '关于', to: '/about' },
  { label: '联系', to: '/contact' },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/search?q=${encodeURIComponent(value)}`);
    setKeyword('');
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
      isActive
        ? 'text-primary-700 bg-primary-50'
        : 'text-foreground-700 hover:text-primary-700 hover:bg-background-100'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-500 to-accent-500 text-background-50 font-heading font-bold text-sm flex items-center justify-center group-hover:scale-105 transition-transform">
            91
          </span>
          <span className="font-heading font-semibold text-lg text-foreground-950 tracking-tight">
            免费91
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 flex-1 justify-start pl-6">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form
            onSubmit={submitSearch}
            className="hidden lg:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-3 pr-1 py-1 w-60 focus-within:border-primary-300 transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm"></i>
            </span>
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索视频 / 软件 / 教程"
              className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
            <button
              type="submit"
              className="shrink-0 w-7 h-7 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 flex items-center justify-center transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line text-sm"></i>
            </button>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="展开导航"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 f91-fade-in">
          <form onSubmit={submitSearch} className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-4 pr-1 py-1 mb-3">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm"></i>
            </span>
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索资源"
              className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
            <button
              type="submit"
              className="shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line text-sm"></i>
            </button>
          </form>
          <div className="flex flex-col">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive ? 'text-primary-700 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}